import { get } from 'lodash'

export const storageGetItem = (name) => {
    return get(window.localStorage, name, '')
}
export const storageSetItem = (name, data) => {
    window.localStorage.setItem(name, data)
}
export const storageRemoveItem = (name) => {
    window.localStorage.removeItem(name)
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Cookie.tsx